import React from 'react';
import PropTypes from 'prop-types';
import { I18n } from 'react-redux-i18n';
import MultiselectFilter from 'components/Filter/MultiselectFilter';
import {
    GROUP_SEVERITY,
} from 'constants/ticket';

const CustomPriority = ({ selected, onChange, isForcedOpen, disabled }) => {
    const options = GROUP_SEVERITY.map(item => ({
        value: item,
        text: I18n.t(`ticket.severity_${ item }`),
    }));

    return (
        <MultiselectFilter
            title={ I18n.t('ticket.priority') }
            options={ options }
            defaultSelected={ selected }
            onChange={ onChange }
            isForcedOpen={ isForcedOpen }
            disabled={ disabled }
        />
    );
};
CustomPriority.propTypes = {
    onChange: PropTypes.func.isRequired,
    selected: PropTypes.arrayOf(PropTypes.number),
    isForcedOpen: PropTypes.bool,
    disabled: PropTypes.bool,
};
CustomPriority.defaultProps = {
    selected: [],
    isForcedOpen: false,
    disabled: false,
};

export default CustomPriority;
